import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import EmailConfigurationAPI from '../../api/EmailConfigurationAPI';
import Display from '../../util/Display';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';

class EmailTemplateList extends React.Component {

  constructor(props) {
    super(props);
    this.emailconfigs = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;
    this.list = { ...this.list, pagination: { currentPage: 1, pageCount: 1, perPage: 10 } };

    const model = reactLocalStorage.getObject(Const.Model).email_config;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() {
    if (this.List) EmailConfigurationAPI.list(this.list, this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => { this.emailconfigs = res; this.setState({ inApiCall: false }); };

  vewDoc = async id => {
    // const res = await DocumentAPI.getPublicMediaUrl(id);
    // window.open(res.url, '_blank');
  };

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to Delete this Configuration?`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      EmailConfigurationAPI.delete(index, this.onDelete, this.onFail);
    });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Configuration Deleted successfully', 'success');
    EmailConfigurationAPI.list(this.list, this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;

    const templatesUI = this.emailconfigs.map((template, _i) => (
      <tr key={`templates_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{template.name}</td>
        <td>{template.host}</td>
        <td>{template.port}</td>
        <td>{template.secure && template.secure === 1 ? 'yes' : 'no'}</td>
        <td>{template.username}</td>
        {/* <td>{template.password}</td> */}
        <td>{Display.ModelLabelValue('user', template.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(template.created_date)}</td>
        <td>{Display.ModelLabelValue('user', template.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(template.updated_date)}</td>
        <td>
          {this.Update &&
            <NavLink to={`${this.path}/add-edit/${template.id}`} className="buttons update">
              <FaPencilAlt /> Update
            </NavLink>
          }
          {template.status !== Const.AlwaysActive && this.Delete &&
            <span onClick={() => this.confirmDelete(template.id)} className="buttons delete">
              <FaTrash /> Delete
            </span>
          }
        </td>
      </tr>
    ));

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 pb-3"><h3>Email Configurations List</h3></div>
            {this.Add &&
              <div className="col-md-6 text-right pb-3">
                <NavLink to={`${this.path}/add-edit/0`} className="buttons success">
                  + Add Email Configuration</NavLink>
              </div>
            }

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Host</th>
                    <th>Post</th>
                    <th>Secure</th>
                    <th>Username</th>
                    {/* <th>Password</th> */}
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{templatesUI}</tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(EmailTemplateList);
